import React, { useState } from "react";
import { authenticateUser } from "../authService"; // Your authentication service
import { Button, Container, Form } from "react-bootstrap";
import { IAuthToken } from "../interfaces";
import "./Auth.css"; // Import custom CSS

export interface IAuthProps {
  baseUrl: string;
  setAuth: (auth: IAuthToken) => void; // Add setAuth callback
}

const Login = (props: IAuthProps) => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [code, setCode] = useState<number | undefined>(undefined);
  const [formErrors, setFormErrors] = useState<string | undefined>(undefined);

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault(); // Prevent form from refreshing the page
    try {
      const user = await authenticateUser(username, password, code);
      props.setAuth(user); // Call setAuth with the authenticated user
    } catch (error) {
      console.error("Login failed:", error);
      setFormErrors(error + "");
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Form className="login-form p-4 border rounded" onSubmit={handleLogin}>
        <Form.Text>Please enter your credentials for Plex:</Form.Text>
        <Form.Group className="mb-3" controlId="formUsername">
          <Form.Control
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formPassword">
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formCode">
          <Form.Control
            type="text"
            value={code}
            onChange={(e) => setCode(Number(e.target.value))}
            placeholder="Code (optional for MFA)"
          />
        </Form.Group>
        {formErrors && <Form.Text className="errors">{formErrors}</Form.Text>}
        <Button className="w-100 mt-2" type="submit">
          Login
        </Button>
      </Form>
    </Container>
  );
};

export default Login;
